import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { AtomModule } from '../../atom/atom.module'
import { environment } from '../../environments/environment'
import { AppService } from '../../service/app.service'

@Component({
  selector: 'app-facebook-signin',
  templateUrl: './facebook-signin.component.html',
  styleUrl: './facebook-signin.component.less',
  standalone: true,
  imports: [AtomModule],
})
export class FacebookSigninComponent implements OnInit {
  @Output() registerClick: EventEmitter<void> = new EventEmitter()
  @Output() token: EventEmitter<string> = new EventEmitter()
  @Output() buttonClick: EventEmitter<void> = new EventEmitter()

  @Input() pluginName = ''
  @Input() text = ''

  isBrowser: boolean

  constructor(private appService: AppService) {}

  ngOnInit() {
    this.appService.isBrowser$.subscribe((state) => {
      this.isBrowser = state

      if (this.isBrowser) {
        window['FB'].init({
          appId: environment.FACEBOOK_APP_ID,
          cookie: true,
          xfbml: true,
          version: 'v22.0',
        })
      }
    })
  }

  login = () => {
    this.buttonClick.emit()
    console.log('facebook login')
    window['FB'].login(
      (response) => {
        if (response.authResponse) {
          console.log('facebook token', response.authResponse.accessToken)
          this.token.emit(response.authResponse.accessToken as string)
        }
      },
      { scope: 'email,public_profile' }
    )
  }
}
